import React, { Component } from 'react';
import {
  Button, ButtonGroup, Container, Col, Row, Table,
} from 'reactstrap';
import axios from 'axios';
import Loan from './widgets/Loan';

class Loans extends Component {
  state = {
    loans: '',
    filtered: '',
    type: 'All',

  }

  componentWillMount() {
    axios.get(`/api/getLoans/${this.props.match.params.clientId}`, {headers:{ Authorization: localStorage.getItem('token') } }).then((response) => {
      // console.log(response.data);
      this.setState({ loans: response.data });
    }).catch((err) => {
      console.log(err.response);
    });
  }

  renderLoans = loans => (
    loans
      ? loans.map((item, i) => (
        <Loan close={this.closeLoan} delete={this.deleteLoan} {...this.props} {...item} no={i + 1} key={item._id} />
      ))
      : null
  )

 closeLoan = (loanId) => {
   if (window.confirm('You cannot undo this! Please be sure')) {
     axios.get(`/api/closeLoan/${loanId}`, {headers:{ Authorization: localStorage.getItem('token') } }).then(({ data }) => {
       axios.get(`/api/getLoans/${this.props.match.params.clientId}`, {headers:{ Authorization: localStorage.getItem('token') } }).then((response) => {
         // console.log(response.data);
         this.setState({ loans: response.data });
       }).catch((err) => {
         console.log(err.response);
       });
     }).catch((err) => {
       window.alert('Failed to close ');
       console.log(err.response);
     });
   } else {
     alert('cancelled');
   }
 };

  deleteLoan = (loanId) => {
    if (window.confirm('You cannot undo this! Please be sure')) {
      axios.delete(`/api/deleteLoan/${loanId}`, {headers:{ Authorization: localStorage.getItem('token') } }).then(({ data }) => {
        axios.get(`/api/getLoans/${this.props.match.params.clientId}`, {headers:{ Authorization: localStorage.getItem('token') } }).then((response) => {
          // console.log(response.data);
          this.setState({ loans: response.data });
        }).catch((err) => {
          console.log(err.response);
        });
      }).catch((err) => {
        window.alert('Failed to delete ');
        console.log(err.response);
      });
    } else {
      alert('cancelled');
    }
  };

  filterLoans = (status) => {
    let type;
    if (status === 1) {
      type = 'Unapproved';
    } else if (status === 5) {
      type = 'Approved';
    } else if (status === 3) {
      type = 'Modification Requested';
    } else if (status === 7) {
      type = 'Disbursed';
    } else if (status === 9) {
      type = 'Rejected';
    }
    const filtered = this.state.loans.filter(item => item.status === status);
    this.setState({ filtered, type });
  }

  render() {
    return (
      <Container>
        <Row>
          <Col className="my-3" md={12}>
            <h2 className="text-center">
              {this.state.type}
              {' '}
Loans for
              {' '}
              {this.props.match.params.clientName}
            </h2>
            {' '}
          </Col>
          <Row className="w-100 text-center mb-1 mt-4">
            <Col xs={12} md={12}>
              <ButtonGroup>
                <Button onClick={() => { this.filterLoans(1); }} color="info">Unapproved</Button>
                <Button onClick={() => { this.filterLoans(5); }} color="success">Approved</Button>
                {/* <Button onClick={() => { this.filterLoans(3); }} color="secondary">Requesting Modification</Button> */}
                <Button onClick={() => { this.filterLoans(7); }} color="primary">Disbursed</Button>
                <Button onClick={() => { this.filterLoans(9); }} color="danger">Rejected</Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Col md={12}>
            <Table striped hover responsive>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Client Id</th>
                  <th>Loan Id</th>

                  <th>Loan Amount</th>
                  {/* <th>Loan Account</th>
                  <th>Repayment Type</th> */}
                  <th>Loan Tenure</th>
                  <th>Submitted On</th>
                  <th>Is Topup</th>
                  <th />
                  <th />
                </tr>
              </thead>
              <tbody>
                {this.renderLoans(this.state.filtered ? this.state.filtered : this.state.loans)}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default Loans;
